// src/api/battleCourseApi.js
import apiClient from "./apiClient";

// 내 공개 코스 리스트
export const listMyCoursesForBattle = (userId) => {
  return apiClient.get("/course/listCourse", {
    params: {
      userId,
      onlyMyCourse: true,
      // search: ""  // 검색 안 쓸 거면 굳이 안 보내도 됨
    },
  });
};
